import { TLegalDocumentType } from "@/data/legal-documents";

export const createFormInitialValues = (legalDocuments: TLegalDocumentType[]): Record<TLegalDocumentType, boolean> => {
  return legalDocuments.reduce(
    (previous, current: TLegalDocumentType) => ({
      ...previous,
      [current]: false,
    }),
    {},
  ) as Record<TLegalDocumentType, boolean>;
};
